export abstract class View {
    public abstract load(): void;
    public abstract unload(): void;
    public abstract draw(): void;
}